// invoicingContext.js
import React, { createContext, useContext, useState } from "react";

const InvoicingContext = createContext();

export const InvoicingProvider = ({ children }) => {
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  // Alert
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [showAlertHeader, setShowAlertHeader] = useState(false);

  const openAlertHeader = () => setShowAlertHeader(true);
  const closeAlertHeader = () => setShowAlertHeader(false);

  // Modales
  const [showViewInvoiceModal, setShowViewInvoiceModal] = useState(false);
  const openViewInvoiceModal = (invoice) => {
    setSelectedInvoice(invoice);
    setShowViewInvoiceModal(true);
  };
  const closeViewInvoiceModal = () => setShowViewInvoiceModal(false);

  const [showResendInvoiceModal, setShowResendInvoiceModal] = useState(false);
  const openResendInvoiceModal = (invoice) => {
    setSelectedInvoice(invoice);
    setShowResendInvoiceModal(true);
  };
  const closeResendInvoiceModal = () => setShowResendInvoiceModal(false);

  const [showRunProcessModal, setShowRunProcessModal] = useState(false);
  const openRunProcessModal = () => setShowRunProcessModal(true);
  const closeRunProcessModal = () => setShowRunProcessModal(false);

  // Para forzar recargas tras procesos (run invoicing, resend, etc.)
  const [apiSuccess, setApiSuccess] = useState(false);
  const changeApiSuccess = () => setApiSuccess((prev) => !prev);

  return (
    <InvoicingContext.Provider
      value={{
        // alerts
        alertType,
        setAlertType,
        message,
        setMessage,
        openAlertHeader,
        closeAlertHeader,
        showAlertHeader,

        // selección
        selectedInvoice,
        setSelectedInvoice,

        // modales
        showViewInvoiceModal,
        openViewInvoiceModal,
        closeViewInvoiceModal,

        showResendInvoiceModal,
        openResendInvoiceModal,
        closeResendInvoiceModal,

        showRunProcessModal,
        openRunProcessModal,
        closeRunProcessModal,

        // reload hook
        apiSuccess,
        changeApiSuccess,
      }}
    >
      {children}
    </InvoicingContext.Provider>
  );
};

export const useInvoicing = () => {
  return useContext(InvoicingContext);
};
